import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import { FaEdit, FaTrashAlt, FaPlus, FaRegEye } from "react-icons/fa";
import { MdDeliveryDining } from "react-icons/md";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import DeleteModal from "../../../components/Modal/DeleteModal";

function CheckBox({ row, status, user, value }) {
  const [isChecked, setIsChecked] = useState(
    row.getValue() === (value === "new" ? "yes" : "active")
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const newChecked = e.target.checked;

    setIsLoading(true);

    axios
      .put(
        `${apiKey}/api/rms/admin/foodMenus/${row.row.original.id}`,
        {
          [status]: newChecked
            ? value === "new"
              ? "yes"
              : "active"
            : value === "new"
            ? "no"
            : "inactive",
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setIsChecked(newChecked);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="relative">
      <input
        type="checkbox"
        className="theme-checkbox"
        checked={isChecked}
        onChange={handleChange}
      ></input>
      {isLoading && (
        <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50 z-10 rounded-full">
          <img
            className="w-4 mx-auto"
            src="https://i.gifer.com/ZKZx.gif"
            alt=""
          />
        </span>
      )}
    </div>
  );
}

function Items() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState("");
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Code") || "Code",
      accessorKey: "code",
    },
    {
      header: languageHelper("Name") || "Name",
      accessorKey: "name",
    },
    {
      header: languageHelper("Name Arabic") || "Name Arabic",
      accessorKey: "name_arabic",
    },
    {
      header: languageHelper("Category") || "Category",
      // accessorKey: "category_name",
      cell: (category) => category.row.original.category?.category_name,
    },
    {
      header: languageHelper("Sale Price") || "Sale Price",
      accessorKey: "sale_price",
    },
    {
      header: languageHelper("Total Ingredients") || "Total Ingredients",
      // accessorKey: "ingredient_count",
      cell: (ing) => ing.row.original.ingredients?.length,
    },
    {
      header: languageHelper("Added By") || "Added By",
      // accessorKey: "added_by",
      cell: (user) => user.row.original.user?.name,
    },
    {
      header: languageHelper("Status") || "Status",
      accessorKey: "status",
      cell: (status) => (
        <CheckBox
          key={`web_status_${status.row.original.id}`}
          row={status}
          status={"status"}
          value={"active"}
          user={user}
        />
      ),
    },
    {
      header: languageHelper("New") || "New",
      accessorKey: "is_new",
      cell: (is_new) => (
        <CheckBox
          key={`web_status_${is_new.row.original.id}`}
          row={is_new}
          status={"is_new"}
          value={"new"}
          user={user}
        />
      ),
    },
    {
      header: languageHelper("Actions") || "Actions",
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ];

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedId, setselectedId] = useState(false);

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/foodMenus/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.data, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchItems();
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const dropdownOptions = [
    {
      name: languageHelper("View Details"),
      icon: <FaRegEye />,
      func: (id) => {
        // Handle view action
        navigate(`viewFoodMenu/${id}`);
      },
    },
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        navigate(`AddItemForm/${id}`);
      },
    },
    {
      name: languageHelper("Assign Add On"),
      icon: <FaPlus />,
      func: (id) => {
        navigate(`assignModifier/${id}`);
      },
    },
    {
      name: languageHelper("Assign Delivery Company"),
      icon: <MdDeliveryDining />,
      func: (id) => {
        navigate(`assignDeliveryCompany/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => {
        // Handle delete action
        setselectedId(id);
      },
    },
  ];

  const buttonData = [
    {
      buttonText: languageHelper("Add Item"),
      path: "AddItemForm",
    },
    {
      buttonText: languageHelper("Upload Items"),
      path: "UploadItems",
    },
    {
      buttonText: languageHelper("Upload Ingredients"),
      path: "UploadIngredients",
    },
  ];

  const handleCategory = (category) => {
    setSelectedCategory(category);
  };

  useState(() => {
    const fetchCategories = (csrfToken) => {
      axios
        .get(`${apiKey}/api/rms/admin/categories`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          params: {
            outletId: user?.user.outlet_id,
          },
        })
        .then((res) => {
          let mappedCategories = res.data.map((cat) => ({
            value: cat.id,
            label: cat.category_name,
          }));
          setCategories(mappedCategories);
        })
        .catch((err) => {
          setError(err.response.data.message);
        });
    };

    handleCSRF(fetchCategories);
  }, [user?.token]);

  const fetchItems = useCallback(
    (csrfToken) => {
      axios
        .get(`${apiKey}/api/rms/admin/foodMenus`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          params: {
            categoryId: selectedCategory,
            outletId: user?.user.outlet_id,
            isDeal: "no",
          },
        })
        .then((res) => {
          setData(res.data.foodMenus);
        })
        .catch((err) => {
          setError(err.response.data.message);
        })
        .finally(() => setPageLoading(false));
    },
    [selectedCategory, user?.token, user?.user.outlet_id]
  );

  useEffect(() => {
    setPageLoading(true);
    handleCSRF(fetchItems);
  }, [fetchItems, selectedCategory, user.token, user.user.outlet_id]);
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        error={error}
        heading={languageHelper("Items")}
        buttonData={buttonData}
        categories={categories}
        handleSelect={handleCategory}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
      {selectedId && (
        <DeleteModal
          setIsOpen={setselectedId}
          onDelete={() => handleDelete(selectedId)}
        />
      )}
    </main>
  );
}

export default Items;
